import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      vi: {
        translation: {
          // Header
          "menu.about": "Giới thiệu",
          "menu.services": "Dịch vụ",
          "menu.knowledge": "Kiến thức",
          "menu.news": "Tin tức",
          "menu.careers": "Tuyển dụng",
          "menu.contact": "Liên hệ",

          // Hero Section
          "hero.title": "DolphinEx – Niềm tin trong kỷ nguyên tài sản mã hóa",
          "hero.description":
            "DolphinEx là công ty fintech thế hệ mới cung cấp dịch vụ tài sản mã hóa an toàn – minh bạch – tuân thủ, hướng tới xây dựng hạ tầng tài chính số cho Việt Nam. Với nền tảng giao dịch hiện đại, chuẩn bảo mật quốc tế, và quản trị rủi ro theo thông lệ toàn cầu, DolphinEx mang đến cho nhà đầu tư Việt Nam môi trường giao dịch thuận tiện, an toàn và đáng tin cậy.",
          "hero.download": "Trải nghiệm DolphinEx Beta",
          "hero.contact": "Đăng ký nhận thông tin ra mắt",

          // Consulting Features
          "consulting.title": "Công nghệ tạo nên niềm tin",
          "consulting.description":
            "DolphinEx kết hợp công nghệ blockchain tiên tiến với tiêu chuẩn bảo mật cấp tổ chức để kiến tạo môi trường giao dịch tài sản mã hóa minh bạch, ổn định và hợp pháp. Chúng tôi tin rằng niềm tin là tài sản giá trị nhất, và mỗi giao dịch an toàn là một viên gạch xây dựng tương lai tài chính số Việt Nam.",
          "consulting.cta": "Tìm hiểu thêm về DolphinEx",
      
          // Business Values
          "business.title": "Bốn trụ cột vận hành niềm tin",
          "business.value1.title": "Bảo mật và An toàn",
          "business.value1.description":
            "Chuẩn mã hóa đa tầng, ví lạnh – ví nóng phân tách, xác thực đa yếu tố để bảo vệ thông tin và tài sản của khách hàng.",
          "business.value2.title": "Tuân thủ",
          "business.value2.description":
            "Đáp ứng và tuân thủ tuyệt đối các tiêu chuẩn theo Nghị Quyết số 5/2025/NQ-CP và các quy định pháp luật liên quan.",
          "business.value3.title": "Minh bạch",
          "business.value3.description":
            "Báo cáo giao dịch, phí và lợi nhuận công khai, dễ kiểm chứng.",
          "business.value4.title": "Phát triển bền vững",
          "business.value4.description":
            "Đồng hành cùng sự hình thành hạ tầng tài chính số quốc gia.",
          
          // Services
          "services.title": "Dịch vụ tài sản mã hóa toàn diện – Một hệ sinh thái, nhiều giá trị",
          // "services.subtitle": "Một hệ sinh thái, nhiều giá trị.",
          "services.service1.title": "Giao dịch tài sản mã hóa",
          "services.service1.description": "Mua bán và chuyển đổi crypto minh bạch, tốc độ cao.",
          "services.service2.title": "Lưu ký tài sản số",
          "services.service2.description": "Bảo mật chuẩn ngân hàng, dữ liệu lưu trữ tại Việt Nam.",
          "services.service3.title": "Tuân thủ & quản trị rủi ro",
          "services.service3.description": "Tự động phát hiện giao dịch bất thường, bảo vệ người dùng.",
          "services.service4.title": "Giải pháp kết nối tổ chức",
          "services.service4.description": "API, SDK, và dịch vụ tích hợp cho ngân hàng, fintech.",
          "services.cta": "Khám phá tất cả dịch vụ",

          // Services Page
          "services.hero.title": "Dịch vụ",
          "services.hero.description": 
            "DolphinEx cung cấp dịch vụ tài sản mã hóa toàn diện, đảm bảo an toàn – minh bạch – tuân thủ, giúp nhà đầu tư Việt Nam dễ dàng tiếp cận, quản lý và phát triển tài sản kỹ thuật số của mình.",
          
          "services.trading.title": "Giao dịch tài sản mã hóa",
          "services.trading.tagline": "Giao dịch nhanh – minh bạch – an toàn.",
          "services.trading.description":
            "DolphinEx vận hành nền tảng khớp lệnh tốc độ cao, bảo mật đa tầng, tích hợp hệ thống quản trị rủi ro và xác thực danh tính KYC.",
          "services.trading.feature1": "Giao diện thân thiện, dữ liệu thị trường theo thời gian thực.",
          "services.trading.feature2": "Cảnh báo rủi ro tự động.",
          "services.trading.feature3": "Phí giao dịch minh bạch, hiển thị rõ ràng.",
          
          "services.custody.title": "Dịch vụ lưu ký tài sản số",
          "services.custody.tagline": "Bảo vệ tài sản mã hóa bằng công nghệ bảo mật cấp ngân hàng.",
          "services.custody.description":
            "DolphinEx sử dụng mô hình ví lạnh – ví nóng phân tách, kết hợp xác thực đa yếu tố (MFA) và mã hóa dữ liệu theo chuẩn quốc tế.",
          "services.custody.feature1": "98% tài sản lưu trong ví lạnh.",
          "services.custody.feature2": "Dữ liệu lưu trữ tại trung tâm dữ liệu nội địa.",
          "services.custody.feature3": "Kiểm toán định kỳ và giám sát 24/7.",
          
          "services.compliance.title": "Tuân thủ & quản trị rủi ro",
          "services.compliance.tagline": "Bảo vệ người dùng và thị trường bằng công nghệ kiểm soát tự động.",
          "services.compliance.description":
            "Hệ thống AML/KYC tích hợp AI giúp phát hiện giao dịch bất thường, ngăn ngừa gian lận và tuân thủ chuẩn FATF.",
          
          "services.institutional.title": "Kết nối tổ chức",
          "services.institutional.description":
            "Cung cấp giải pháp API, SDK và dịch vụ tích hợp cho ngân hàng, fintech, công ty đầu tư và tổ chức quản lý tài sản.",
          "services.institutional.feature1": "API giao dịch tài sản mã hóa.",
          "services.institutional.feature2": "Dịch vụ thanh toán và quy đổi.",
          "services.institutional.feature3": "Lưu ký và đối soát dữ liệu chuẩn tuân thủ.",
          "services.institutional.feature4": "Giải pháp co-branded / white-label theo yêu cầu đối tác.",
          
          "services.features.title": "Tính năng chính:",
          "services.commitment.title": "Cam kết:",
          "services.solutions.title": "Giải pháp chính:",
          "services.cta.title": "Liên hệ để tìm hiểu thêm về giải pháp DolphinEx",
          "services.cta.button": "Liên hệ ngay →",

          // Final CTA
          "finalCta.title": "Gia nhập DolphinEx – Kiến tạo tương lai tài chính số Việt Nam",
          "finalCta.description": "Cùng chúng tôi xây dựng thị trường tài sản mã hóa minh bạch, bền vững và đáng tin cậy.",
          "finalCta.contact": "Liên hệ hợp tác",
          "finalCta.partner": "Đăng ký đối tác",

          // Partners
          "partners.title": "Đối tác",

          // Introduction
          "introduction.hero.title": "Kiến tạo hạ tầng tài chính số Việt Nam",
          "introduction.hero.description1":
            "DolphinEx là công ty fintech thế hệ mới, tiên phong trong lĩnh vực dịch vụ tài sản mã hóa (Digital Asset Services).",
          "introduction.hero.description2":
            "Sứ mệnh của DolphinEx là xây dựng môi trường đầu tư an toàn, minh bạch, tuân thủ, góp phần thúc đẩy thị trường tài sản số phát triển bền vững.",
          
          "introduction.vision.sectionTitle": "Tầm nhìn – Sứ mệnh – Giá trị",
          "introduction.vision.label": "Tầm nhìn",
          "introduction.vision.description":
            "Trở thành công ty dẫn đầu về cung cấp dịch vụ tài sản mã hóa tại Việt Nam, đóng góp vào việc hình thành hạ tầng tài chính số quốc gia.",
          
          "introduction.mission.label": "Sứ mệnh",
          "introduction.mission.description":
            "Đưa công nghệ tài chính tiên tiến đến gần hơn với người Việt, mang lại trải nghiệm đầu tư đáng tin cậy và tuân thủ pháp luật.",
          
          "introduction.values.title": "Giá trị",
          "introduction.values.value1": "Bảo mật & An toàn",
          "introduction.values.value2": "Tuân thủ",
          "introduction.values.value3": "Minh bạch",
          "introduction.values.value4": "Phát triển bền vững",
          
          "introduction.brandMessage.title": "",
          "introduction.brandMessage.description1":
            "Trong kỷ nguyên tài sản số, niềm tin chính là đơn vị giá trị cao nhất.",
          "introduction.brandMessage.description2":
            "DolphinEx không chỉ là công nghệ",
          "introduction.brandMessage.description3":
            "mà là nền tảng niềm tin được xây dựng cho thị trường tài chính số Việt Nam.",


          // Knowledge Page
          "knowledge.hero.title": "Kiến thức tài sản mã hóa – Học để hiểu, đầu tư để thành công",
          "knowledge.hero.description1": "Trang Kiến thức DolphinEx là trung tâm chia sẻ tri thức và công cụ học tập dành cho nhà đầu tư Việt Nam trong kỷ nguyên tài sản số.",
          "knowledge.hero.description2": "Chúng tôi giúp bạn xây nền tảng hiểu biết vững chắc, hiểu rõ rủi ro, và đưa ra quyết định đầu tư thông minh dựa trên dữ liệu, công nghệ và tuân thủ pháp lý.",
          "knowledge.hero.cta1": "Khám phá học liệu mới nhất →",
          "knowledge.hero.cta2": "Nhận tài liệu hướng dẫn miễn phí",
          
          "knowledge.academy.title": "Kiến thức cơ bản đến nâng cao – Dành cho mọi cấp độ nhà đầu tư",
          "knowledge.academy.sectionTitle": "Học viện tài sản số",
          "knowledge.academy.basic.title": "Cơ bản",
          "knowledge.academy.basic.description": "Blockchain là gì? Token – Coin khác nhau thế nào?",
          "knowledge.academy.intermediate.title": "Trung cấp",
          "knowledge.academy.intermediate.description": "Cách đọc biểu đồ, phân tích giá, quản lý danh mục.",
          "knowledge.academy.advanced.title": "Nâng cao",
          "knowledge.academy.advanced.description": "Định danh dự án, staking, lưu ký, quản trị rủi ro.",
          "knowledge.academy.status": "Sắp ra mắt",
          
          "knowledge.guides.title": "Từng bước xây dựng hành trình đầu tư an toàn với DolphinEx",
          "knowledge.guides.sectionTitle": "Hướng dẫn sử dụng & an toàn đầu tư",
          "knowledge.guides.item1": "Cách mở tài khoản và xác thực KYC đúng chuẩn.",
          "knowledge.guides.item2": "Quản lý ví lưu ký và chuyển tài sản mã hóa an toàn.",
          "knowledge.guides.item3": "Cách nhận biết dự án hoặc token tiềm năng.",
          "knowledge.guides.item4": "Nguyên tắc bảo mật thông tin, phòng tránh scam và lừa đảo.",
          
          "knowledge.toolkit.title": "Công cụ thông minh – Quyết định thông minh",
          "knowledge.toolkit.sectionTitle": "Bộ công cụ & tài nguyên",
          "knowledge.toolkit.description": "DolphinEx cung cấp các công cụ tính toán, biểu đồ và tài liệu phân tích miễn phí:",
          "knowledge.toolkit.item1.title": "Crypto Risk Score",
          "knowledge.toolkit.item1.description": "Đánh giá mức rủi ro danh mục.",
          "knowledge.toolkit.item2.title": "Market Tracker",
          "knowledge.toolkit.item2.description": "Theo dõi biến động giá và vốn hóa.",
          "knowledge.toolkit.item3.title": "Glossary",
          "knowledge.toolkit.item3.description": "Từ điển thuật ngữ tài sản số Việt–Anh.",
          "knowledge.toolkit.item4.title": "Workbook",
          "knowledge.toolkit.item4.description": "Tài liệu tự học & quản trị danh mục đầu tư.",
          "knowledge.toolkit.status": "Sắp ra mắt",
          
          "knowledge.expert.title": "Quan điểm, chiến lược và triết lý đầu tư từ đội ngũ chuyên gia DolphinEx",
          "knowledge.expert.sectionTitle": "Góc chuyên gia",
          "knowledge.expert.description": "Nơi đội ngũ chuyên gia fintech, blockchain và pháp lý của DolphinEx chia sẻ:",
          "knowledge.expert.card1.title": "Phân tích xu hướng thị trường",
          "knowledge.expert.item1": "Bài phân tích chuyên sâu về xu hướng tài sản mã hóa.",
          "knowledge.expert.card2.title": "Chiến lược & Quản trị rủi ro",
          "knowledge.expert.item2": "Triết lý đầu tư dài hạn và quản trị rủi ro.",
          "knowledge.expert.card3.title": "Chính sách & Tuân thủ",
          "knowledge.expert.item3": "Nhận định về tác động của chính sách, pháp lý tới thị trường.",
          "knowledge.expert.status": "Sắp ra mắt",
          "knowledge.expert.cta.title": "Đăng ký nhận thông báo bài viết mới",
          "knowledge.expert.cta.description": "Các bài viết chuyên sâu từ đội ngũ chuyên gia DolphinEx sẽ sớm được công bố. Đăng ký để không bỏ lỡ các phân tích và insights giá trị.",
          "knowledge.expert.cta.button": "Đăng ký ngay",
          
          "knowledge.finalCta.title": "Biến kiến thức thành sức mạnh đầu tư",
          "knowledge.finalCta.description": "Theo dõi DolphinEx để không bỏ lỡ bài học, công cụ và chiến lược giúp bạn đầu tư hiệu quả, an toàn và minh bạch.",
          "knowledge.finalCta.button1": "Tham gia cộng đồng học viên DolphinEx →",
          "knowledge.finalCta.button2": "Đăng ký bản tin kiến thức miễn phí",

          // News
          "news.title": "Tin tức & Phân tích",
          "news.subtitle1": "Cập nhật xu hướng, phân tích thị trường và góc nhìn chuyên sâu từ các chuyên gia DolphinEx.",
          "news.subtitle2": "Nơi bạn tìm thấy kiến thức – minh bạch – niềm tin trong thế giới tài sản mã hóa.",
          "news.categoriesTitle": "Chuyên mục",
          "news.categories.market": "Thị trường tài sản số",
          "news.categories.blockchain": "Blockchain & Công nghệ",
          "news.categories.compliance": "Pháp lý & Tuân thủ",
          "news.categories.analysis": "Phân tích chuyên sâu",
          "news.categories.announcements": "Công bố thông tin",
          "news.comingSoon.title": "Nội dung đang được cập nhật",
          "news.comingSoon.description": "Chúng tôi đang chuẩn bị các bài viết chất lượng cao về thị trường tài sản mã hóa, xu hướng công nghệ và phân tích chuyên sâu. Vui lòng quay lại sau.",
          "news.cta.title": "Đăng ký nhận thông báo khi có tin mới",
          "news.cta.button": "Xem tin mới nhất →",

          // Contact Form
          "contact.title": "Liên hệ với DolphinEx",
          "contact.subtitle":
            "Chúng tôi luôn sẵn sàng đồng hành cùng bạn trong hành trình khám phá, đầu tư và phát triển tài sản mã hóa an toàn và bền vững. Hãy để lại thông tin, đội ngũ DolphinEx sẽ liên hệ với bạn trong thời gian sớm nhất.",
          "contact.name": "Họ và tên",
          "contact.name.placeholder": "Nhập tên của bạn",
          "contact.email": "Email",
          "contact.email.placeholder": "Nhập email của bạn",
          "contact.message": "Nội dung yêu cầu",
          "contact.message.placeholder":
            "Vui lòng cho biết DolphinEx có thể hỗ trợ gì cho quý khách",
          "contact.submit": "Gửi yêu cầu hợp tác",
          "contact.submit2": "Đặt lịch trao đổi với đội ngũ DolphinEx",
          "contact.company.name": "DolphinEx",
          "contact.company.intro":
            "DolphinEx là công ty fintech thế hệ mới cung cấp dịch vụ tài sản mã hóa an toàn – minh bạch – tuân thủ, hướng tới xây dựng hạ tầng tài chính số cho Việt Nam.",
          "contact.company.email": "contact@dolphinex.com.vn",
          "contact.company.hotline": "(+84) xxx xxx xxx",
          "contact.company.address": "Hà Nội",
          "contact.company.website": "www.dolphinex.com.vn",
          "contact.address": "Địa chỉ",
          "contact.phone": "Số điện thoại",
          "contact.phone.placeholder": "Nhập số điện thoại của bạn",
          "contact.represent": "Đại diện",
          "contact.hotline": "Hotline",
          "contact.website": "Website",

          // Footer
          "footer.notice.line1": "Website đang trong quá trình phát triển và thử nghiệm.",
          "footer.notice.line2": "Website sẽ chính thức vận hành sau khi được cấp phép.",

          // hero-operating
          "hero.operating.title": "Lĩnh vực hoạt động",
          // Progress Steps
          "progress.title": "Quy trình tư vấn giá BĐS của LaFin",
          "progress.step1.title": "Tiếp nhận thông tin",
          "progress.step1.description": "Bước 1",
          "progress.step2.title": "Tự động xác định tiêu chí so sánh",
          "progress.step2.description": "Bước 2",
          "progress.step3.title": "Tìm kiếm tài sản so sánh",
          "progress.step3.description": "Bước 3",
          "progress.step4.title": "Phân tích và tính toán",
          "progress.step4.description": "Bước 4",
          "progress.step5.title": "Lập báo cáo tự động",
          "progress.step5.description": "Bước 5",
        },
      },
      en: {
        translation: {
          // Header
          "menu.about": "About",
          "menu.services": "Services",
          "menu.knowledge": "Knowledge",
          "menu.news": "News",
          "menu.careers": "Careers",
          "menu.contact": "Contact",

          // Hero Section
          "hero.title": "DolphinEx – Trust in the Era of Tokenized Assets.",
          "hero.description":
            "DolphinEx is a next-generation fintech company providing secure, transparent, and compliant tokenized asset services, aiming to build digital financial infrastructure for Vietnam. With a modern trading platform, international security standards, domestic data storage, and global risk management practices, DolphinEx brings Vietnamese investors a convenient, safe, and trustworthy trading environment.",
          "hero.download": "Try DolphinEx Beta",
          "hero.contact": "Register for Launch Updates",

          // Consulting Features
          "consulting.title": "Technology Builds Trust.",
          "consulting.description":
            "DolphinEx combines advanced blockchain technology with enterprise-grade security standards to create a transparent, stable, and compliant tokenized asset trading environment. We believe trust is the most valuable asset, and every secure transaction is a building block for Vietnam's digital financial future.",
          "consulting.cta": "Learn More About DolphinEx",
          "consulting.feature1.title":
            "Automatically Identifies Suitable Comparable Properties",
          "consulting.feature1.description":
            "The AI-powered system helps users quickly determine the most suitable comparable properties for appraisal based on pre-set criteria and priority levels.",
          "consulting.feature2.title":
            "AI-Generated Adjustment Ratio for Comparable Properties",
          "consulting.feature2.description":
            "Our AI system assists users in determining the most appropriate adjustment ratios, ensuring that the compared properties accurately reflect the characteristics of the property being appraised.",
          "consulting.feature3.title": "Receive Real estate appraisal Results",
          "consulting.feature3.description":
            "The system automatically calculates the value of structures on land, land value, and unit price of land.",
          "consulting.image_alt": "Dashboard Preview",

          // Business Values
          "business.title": "Four Pillars of Trust.",
          "business.value1.title": "Security & Safety",
          "business.value1.description":
            "Multi-layer encryption, segregated cold-hot wallets, and multi-factor authentication to protect customer information and assets.",
          "business.value2.title": "Compliance",
          "business.value2.description":
            "Meeting and fully complying with standards under Resolution No. 5/2025/NQ-CP and related legal regulations.",
          "business.value3.title": "Transparency",
          "business.value3.description":
            "Public and easily verifiable transaction reports, fees, and profits.",
          "business.value4.title": "Sustainable Development",
          "business.value4.description":
            "Partnering in building the nation's digital financial infrastructure.",
          
          // Services
          "services.title": "Comprehensive Tokenized Asset Services – One Ecosystem, Many Values",
          // "services.subtitle": "A comprehensive ecosystem delivering multiple values to Vietnamese investors.",
          "services.service1.title": "Crypto Asset Trading",
          "services.service1.description": "Transparent, high-speed buying, selling, and crypto conversion.",
          "services.service2.title": "Digital Asset Custody",
          "services.service2.description": "Bank-grade security, data stored in Vietnam.",
          "services.service3.title": "Compliance & Risk Management",
          "services.service3.description": "Automatic detection of unusual transactions, protecting users.",
          "services.service4.title": "Institutional Integration Solutions",
          "services.service4.description": "API, SDK, and integration services for banks and fintech.",
          "services.cta": "Explore All Services",

          // Services Page
          "services.hero.title": "Services",
          "services.hero.description": 
            "DolphinEx provides comprehensive tokenized asset services, ensuring security, transparency, and compliance, helping Vietnamese investors easily access, manage, and grow their digital assets.",
          
          "services.trading.title": "Crypto Asset Trading",
          "services.trading.tagline": "Fast – Transparent – Secure Trading.",
          "services.trading.description":
            "DolphinEx operates a high-speed matching platform with multi-layer security, integrated risk management system, and KYC identity verification.",
          "services.trading.feature1": "User-friendly interface with real-time market data.",
          "services.trading.feature2": "Automatic risk alerts.",
          "services.trading.feature3": "Transparent trading fees, clearly displayed.",
          
          "services.custody.title": "Digital Asset Custody Service",
          "services.custody.tagline": "Protecting tokenized assets with bank-grade security technology.",
          "services.custody.description":
            "DolphinEx uses segregated cold-hot wallet model, combined with multi-factor authentication (MFA) and international standard data encryption.",
          "services.custody.feature1": "98% of assets stored in cold wallets.",
          "services.custody.feature2": "Data stored at domestic data centers.",
          "services.custody.feature3": "Regular audits and 24/7 monitoring.",
          
          "services.compliance.title": "Compliance & Risk Management",
          "services.compliance.tagline": "Protecting users and markets with automated control technology.",
          "services.compliance.description":
            "AI-integrated AML/KYC system helps detect unusual transactions, prevent fraud, and comply with FATF standards.",
          
          "services.institutional.title": "Institutional Service",
          "services.institutional.description":
            "Providing API, SDK solutions and integration services for banks, fintech, investment companies, and asset management institutions.",
          "services.institutional.feature1": "Tokenized asset trading API.",
          "services.institutional.feature2": "Payment and conversion services.",
          "services.institutional.feature3": "Custody and data reconciliation with compliance standards.",
          "services.institutional.feature4": "Co-branded / white-label solutions as per partner requirements.",
          
          "services.features.title": "Key Features:",
          "services.commitment.title": "Our Commitment:",
          "services.solutions.title": "Main Solutions:",
          "services.cta.title": "Contact us to learn more about DolphinEx solutions",
          "services.cta.button": "Contact Now →",

          // Final CTA
          "finalCta.title": "Join DolphinEx – Build Vietnam's Digital Financial Future.",
          "finalCta.description": "Partner with us to build a transparent, sustainable, and trustworthy tokenized asset market.",
          "finalCta.contact": "Contact for Partnership",
          "finalCta.partner": "Register as Partner",

          // Partners
          "partners.title": "Partners",

          // Introduction
          "introduction.hero.title": "Building Vietnam's Digital Financial Infrastructure.",
          "introduction.hero.description1":
            "DolphinEx is a next-generation fintech company pioneering in Digital Asset Services.",
          "introduction.hero.description2":
            "DolphinEx's mission is to build a safe, transparent, and compliant investment environment, contributing to the sustainable development of the digital asset market.",
          
          "introduction.vision.sectionTitle": "Vision – Mission – Values",
          "introduction.vision.label": "Vision",
          "introduction.vision.description":
            "To become the leading company in providing tokenized asset services in Vietnam, contributing to the formation of national digital financial infrastructure.",
          
          "introduction.mission.label": "Mission",
          "introduction.mission.description":
            "Bringing advanced financial technology closer to Vietnamese people, providing trustworthy and legally compliant investment experiences.",
          
          "introduction.values.title": "Values",
          "introduction.values.value1": "Security & Safety",
          "introduction.values.value2": "Compliance",
          "introduction.values.value3": "Transparency",
          "introduction.values.value4": "Sustainable Development",
          
          "introduction.brandMessage.title": "",
          "introduction.brandMessage.description1":
            "In the era of digital assets, trust is the highest unit of value.",
          "introduction.brandMessage.description2":
            "DolphinEx is not just technology",
          "introduction.brandMessage.description3":
            "it is a trust platform built for Vietnam's digital financial market.",

          // Careers
          "careers.title":
            "At LaFin, we are building a dynamic, creative and challenging working environment, where every idea is valued and can create opportunities for development. As the first startup to apply AI technology to data analysis, we create an open space for Team members to trade, share knowledge and grow together.",
          "careers.company_size": "Company Size",
          "careers.working_hours": "Working Hours",
          "careers.location": "Location",

          // Knowledge Page
          "knowledge.hero.title": "Tokenized Asset Knowledge – Learn to Understand, Invest to Succeed",
          "knowledge.hero.description1": "DolphinEx Knowledge Hub is a center for sharing knowledge and learning tools for Vietnamese investors in the digital asset era.",
          "knowledge.hero.description2": "We help you build a solid foundation of understanding, comprehend risks, and make smart investment decisions based on data, technology, and legal compliance.",
          "knowledge.hero.cta1": "Explore Latest Learning Materials →",
          "knowledge.hero.cta2": "Get Free Guide Materials",
          
          "knowledge.academy.title": "From Basic to Advanced Knowledge – For All Investor Levels",
          "knowledge.academy.sectionTitle": "Crypto Academy",
          "knowledge.academy.basic.title": "Basic",
          "knowledge.academy.basic.description": "What is Blockchain? How are Tokens and Coins different?",
          "knowledge.academy.intermediate.title": "Intermediate",
          "knowledge.academy.intermediate.description": "How to read charts, analyze prices, manage portfolios.",
          "knowledge.academy.advanced.title": "Advanced",
          "knowledge.academy.advanced.description": "Project identification, staking, custody, risk management.",
          "knowledge.academy.status": "Coming Soon",
          
          "knowledge.guides.title": "Step by step building a safe investment journey with DolphinEx",
          "knowledge.guides.sectionTitle": "User Guides & Investment Safety",
          "knowledge.guides.item1": "How to open an account and complete KYC verification properly.",
          "knowledge.guides.item2": "Managing custody wallets and safely transferring tokenized assets.",
          "knowledge.guides.item3": "How to identify potential projects or tokens.",
          "knowledge.guides.item4": "Information security principles, avoiding scams and fraud.",
          
          "knowledge.toolkit.title": "Smart Tools – Smart Decisions",
          "knowledge.toolkit.sectionTitle": "Investor Toolkit",
          "knowledge.toolkit.description": "DolphinEx provides free calculation tools, charts, and analytical materials:",
          "knowledge.toolkit.item1.title": "Crypto Risk Score",
          "knowledge.toolkit.item1.description": "Portfolio risk assessment.",
          "knowledge.toolkit.item2.title": "Market Tracker",
          "knowledge.toolkit.item2.description": "Track price fluctuations and market capitalization.",
          "knowledge.toolkit.item3.title": "Glossary",
          "knowledge.toolkit.item3.description": "Vietnamese-English digital asset terminology dictionary.",
          "knowledge.toolkit.item4.title": "Workbook",
          "knowledge.toolkit.item4.description": "Self-study materials & investment portfolio management.",
          "knowledge.toolkit.status": "Coming Soon",
          
          "knowledge.expert.title": "Perspectives, strategies, and investment philosophy from DolphinEx expert team",
          "knowledge.expert.sectionTitle": "Expert Corner",
          "knowledge.expert.description": "Where DolphinEx's fintech, blockchain, and legal experts share:",
          "knowledge.expert.card1.title": "Market Trend Analysis",
          "knowledge.expert.item1": "In-depth analysis on tokenized asset trends.",
          "knowledge.expert.card2.title": "Strategy & Risk Management",
          "knowledge.expert.item2": "Long-term investment philosophy and risk management.",
          "knowledge.expert.card3.title": "Policy & Compliance",
          "knowledge.expert.item3": "Insights on policy and legal impacts on the market.",
          "knowledge.expert.status": "Coming Soon",
          "knowledge.expert.cta.title": "Subscribe for New Article Notifications",
          "knowledge.expert.cta.description": "In-depth articles from DolphinEx expert team will be published soon. Subscribe to not miss valuable analysis and insights.",
          "knowledge.expert.cta.button": "Subscribe Now",
          
          "knowledge.finalCta.title": "Transform Knowledge into Investment Power",
          "knowledge.finalCta.description": "Follow DolphinEx to not miss lessons, tools, and strategies that help you invest effectively, safely, and transparently.",
          "knowledge.finalCta.button1": "Join DolphinEx Learning Community →",
          "knowledge.finalCta.button2": "Subscribe to Free Knowledge Newsletter",

          // News
          "news.title": "News & Insights",
          "news.subtitle1": "Stay updated with trends, market analysis, and expert insights from DolphinEx professionals.",
          "news.subtitle2": "Where you find knowledge – transparency – trust in the world of tokenized assets.",
          "news.categoriesTitle": "Categories",
          "news.categories.market": "Digital Asset Market",
          "news.categories.blockchain": "Blockchain & Technology",
          "news.categories.compliance": "Legal & Compliance",
          "news.categories.analysis": "In-Depth Analysis",
          "news.categories.announcements": "Announcements",
          "news.comingSoon.title": "Content Coming Soon",
          "news.comingSoon.description": "We are preparing high-quality articles about the tokenized asset market, technology trends, and in-depth analysis. Please check back later.",
          "news.cta.title": "Subscribe for New Updates",
          "news.cta.button": "View Latest News →",

          // Contact Form
          "contact.title": "Contact DolphinEx",
          "contact.subtitle":
            "We are always ready to accompany you on your journey to explore, invest, and develop tokenized assets safely and sustainably. Leave your information, and the DolphinEx team will contact you as soon as possible.",
          "contact.name": "Full Name",
          "contact.name.placeholder": "Enter your name",
          "contact.email": "Email",
          "contact.email.placeholder": "Enter your email",
          "contact.message": "Message",
          "contact.message.placeholder":
            "Please let us know how DolphinEx can assist you",
          "contact.submit": "Send Partnership Request",
          "contact.submit2": "Schedule a Meeting with DolphinEx Team",
          "contact.company.name": "DolphinEx",
          "contact.company.intro":
            "DolphinEx is a next-generation fintech company providing secure, transparent, and compliant tokenized asset services, aiming to build digital financial infrastructure for Vietnam.",
          "contact.company.email": "contact@dolphinex.com.vn",
          "contact.company.hotline": "(+84) xxx xxx xxx",
          "contact.company.address": "Hanoi",
          "contact.company.website": "www.dolphinex.com.vn",
          "contact.address": "Address",
          "contact.phone": "Phone Number",
          "contact.phone.placeholder": "Enter your phone number",
          "contact.represent": "Represent",
          "contact.hotline": "Hotline",
          "contact.website": "Website",
          
          // Footer
          "footer.notice.line1": "This website is currently under development and testing.",
          "footer.notice.line2": "The website will officially operate after being licensed.",

          // Introduction
          "introduction.title": "About Us",
          "introduction.info":
            "LaFin is a technology platform that provides AI-powered real estate appraisal consulting services. Using Artificial Intelligence (AI), Machine Learning, and Big Data analytics, LaFin focuses on transforming the real estate appraisal industry in Vietnam. Our mission is to bring transparency, accuracy, and speed to the appraisal process through AI and Big Data applications.",
          "introduction.misstion-one":
            "Applying AI and data to simplify and enhance real estate appraisal processes, setting a new standard for efficiency and accuracy in Vietnam’s market.",
          "introduction.misstion-two":
            "LaFin aims to become the leading provider of AI-powered real estate appraisal solutions in Vietnam. We are committed to continuous innovation and development to bring the best value to our partners.",
          "introduction.group-title":
            "Do everything with passion or not at all",
          "introduction.group-description": "Rosa Nouchette Carey",
          "introduction.member-title": "Leadership Team",
          "introduction.misstion-title": "Mission & Vision",

          // hero-operating
          "hero.operating.title": "Business sector",
          // Progress Steps
          "progress.title": "LaFin's Valuation Consulting Process",
          "progress.step1.title": "Information Analysis",
          "progress.step1.description": "Step 1",
          "progress.step2.title": "Automated Comparable Criteria Selection",
          "progress.step2.description": "Step 2",
          "progress.step3.title": "Comparable Property Search",
          "progress.step3.description": "Step 3",
          "progress.step4.title": "Analysis and Calculation",
          "progress.step4.description": "Step 4",
          "progress.step5.title": "Automated Reporting",
          "progress.step5.description": "Step 5",
        },
      },
    },
    fallbackLng: "vi",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
